import type { TileResourceData, TileResourceKind } from '@/plugins/tiles/contracts'
import { TilesError } from '@/plugins/tiles/TilesError'

export interface TileResourceClassification {
  readonly kind: TileResourceKind
  readonly json?: Record<string, unknown>
}

/** 仅检查容器前缀或 JSON 结构，不引入任何 Mesh 解码依赖。 */
export function classifyTileResource(data: TileResourceData): TileResourceClassification {
  if (data.data.byteLength >= 4) {
    const magic = new DataView(data.data).getUint32(0, true)
    if (magic === 0x46546c67) return { kind: 'mesh' }
    if ([0x6d643362, 0x6d643369, 0x73746e70, 0x74706d63].includes(magic)) {
      return { kind: 'unsupported' }
    }
  }
  const text = new TextDecoder()
    .decode(data.data)
    .replace(/^\uFEFF/, '')
    .trim()
  if (!text.startsWith('{')) return { kind: data.complete ? 'unsupported' : 'unknown' }
  let json: unknown
  try {
    json = JSON.parse(text)
  } catch (cause) {
    if (!data.complete) return { kind: 'unknown' }
    throw new TilesError(
      {
        code: 'invalid-resource',
        stage: 'request',
        sourceUrl: data.url,
        message: `Tiles 资源 JSON 无效: ${data.url}`,
      },
      { cause }
    )
  }
  if (!json || typeof json !== 'object' || Array.isArray(json)) return { kind: 'unsupported' }
  const document = json as Record<string, unknown>
  if ('root' in document && 'geometricError' in document) {
    return { kind: 'tileset', json: document }
  }
  if ('asset' in document) return { kind: 'mesh', json: document }
  return { kind: 'unsupported', json: document }
}
